import React from "react";

const services = [
  {
    title: "Custom Jewellery Design",
    desc: "Bring your dream piece to life  our master karigars handcraft bespoke ornaments tailored to your vision and occasion.",
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 19l7-7 3 3-7 7-3-3z" />
        <path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z" />
        <path d="M2 2l7.586 7.586" />
        <circle cx="11" cy="11" r="2" />
      </svg>
    ),
  },
  {
    title: "Gold Exchange",
    desc: "Trade your old gold for brand new designs at the most transparent and fair rates  no hidden deductions.",
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="23 4 23 10 17 10" />
        <polyline points="1 20 1 14 7 14" />
        <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
      </svg>
    ),
  },
  {
    title: "Bridal Consultation",
    desc: "Book a private bridal session  we'll curate the perfect trousseau, from mangal sutra to full sets, with love.",
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
      </svg>
    ),
  },
  {
    title: "Repair & Polish",
    desc: "Restore your cherished pieces to their original glow  expert cleaning, re-polishing, re-stringing and repair services.",
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
      </svg>
    ),
  },
  {
    title: "Hallmark Certification",
    desc: "Every piece carries BIS hallmark certification. Purity guaranteed, clearly stamped  no compromise, ever.",
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
        <polyline points="22 4 12 14.01 9 11.01" />
      </svg>
    ),
  },
  {
    title: "Silver & Gifts",
    desc: "From silver pooja articles to elegant keepsakes  the perfect thoughtful gift for every celebration.",
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 12 20 22 4 22 4 12" />
        <rect x="2" y="7" width="20" height="5" />
        <line x1="12" y1="22" x2="12" y2="7" />
        <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" />
        <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" />
      </svg>
    ),
  },
];

export default function Services() {
  return (
    <section
      id="services"
      className="relative py-16 sm:py-20 md:py-28 bg-gradient-to-b from-white via-cream to-white overflow-hidden"
    >
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
        <div className="absolute top-20 -left-20 w-72 h-72 rounded-full bg-gold/10 blur-3xl" />
        <div className="absolute bottom-20 -right-20 w-72 h-72 rounded-full bg-maroon/10 blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 md:px-10">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.35em] text-gold-dark font-semibold mb-4">
            <span className="h-px w-8 bg-gold" />
            Why Us
            <span className="h-px w-8 bg-gold" />
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-maroon font-bold leading-tight">
            The SMS Gold{" "}
            <span className="gold-gradient-text">Difference</span>
          </h2>
          <p className="mt-4 sm:mt-5 text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed">
            For over nine decades and five generations, we've stood for
            heritage, purity and unwavering trust. Here's what sets us apart.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {services.map((s, i) => (
            <div
              key={i}
              className="group relative bg-white rounded-2xl p-6 md:p-7 border border-gray-200 hover:border-gold shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden"
            >
              <div className="absolute top-0 right-0 w-24 h-24 bg-gold/5 rounded-full blur-2xl group-hover:bg-gold/15 transition-colors" />
              <div className="relative w-14 h-14 flex items-center justify-center rounded-2xl bg-gradient-to-br from-maroon to-maroon-dark text-gold mb-5 group-hover:from-gold group-hover:to-gold-dark group-hover:text-white transition-all">
                {s.icon}
              </div>
              <h3 className="relative font-serif text-lg md:text-xl text-maroon font-bold mb-2">
                {s.title}
              </h3>
              <p className="relative text-gray-600 text-sm leading-relaxed">
                {s.desc}
              </p>
              <div className="relative mt-4 text-gold-dark text-xs font-semibold uppercase tracking-wider flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                Learn More
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
